import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { Pool } from '../../types/pool-plans.types';
import { useAppQuery } from '../use-app-query.hook';

export const usePool = ({
  companyId,
  poolId,
  enabled = true,
}: {
  companyId: string;
  /**
   * False keeps serving the cached pool without fetching it — for an always-mounted modal that is
   * closed, so an invalidation does not refetch (and 404 on) a pool nobody is looking at.
   */
  enabled?: boolean;
  poolId: string;
}) => {
  const queryClient = useQueryClient();

  const { data: pool, isLoading } = useAppQuery<Pool>({
    queryKey: [QueryKey.GET_POOL, companyId, poolId],
    queryFn: () =>
      ApiService.get({ endpoint: BackendRoute.COMPANIES, routePath: [companyId, 'pools', poolId] }),
    enabled: enabled && !!companyId && !!poolId,
  });

  const invalidateQuery = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [QueryKey.GET_POOL] });
  }, [queryClient]);

  return {
    invalidateQuery,
    pool,
    isLoading,
  };
};
